// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connect-box[data-v-266334f1] {\n  display: flex;\n}\n.connect-box span[data-v-266334f1] {\n  margin: 0 10px;\n}\n.connect-box > div[data-v-266334f1] {\n  display: flex;\n}\n.connect-box > div > div[data-v-266334f1] {\n  margin: 0 5px;\n}\n.connect-box > div > div[data-v-266334f1]:first-child {\n  margin-left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
